interface CheckoutHeaderProps {
  companyName: string;
}

export function CheckoutHeader({ companyName }: CheckoutHeaderProps) {
  return (
    <div className="bg-black">
      {/* Spring Sale Banner */}
      <div className="bg-black px-2.5 py-2 sm:py-[10px]">
        <div className="mx-auto max-w-[1170px]">
          <div className="text-center">
            <p className="m-0 p-0 font-montserrat text-base sm:text-lg md:text-[22px] leading-[1.3] text-white">
              <span>🌸 </span>
              <strong>SPRING SALE</strong>
            </p>
            <h3 className="m-0 p-[5px] font-montserrat text-sm sm:text-base md:text-[18px] leading-none text-[rgb(253,204,94)]">
              <strong>ATTENTION: </strong>
              <span className="text-white">Coupon Code </span>
              <strong className="text-white">
                <em>(T7K3nk5) </em>
              </strong>
              <span className="text-white">
                Applied. Limited Inventory. Sell Out Risk High.
              </span>
            </h3>
          </div>
        </div>
      </div>

      {/* Secure Checkout Section */}
      <section
        className="flex flex-row items-center justify-center w-full px-4"
        style={{
          backgroundColor: "rgb(255, 228, 228)",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Desktop Layout */}
        <div
          className="hidden md:flex flex-row items-center justify-between max-w-5xl w-full"
          style={{ margin: "0px", padding: "0px" }}
        >
          {/* Logo */}
          <div className="m-2.5">
            <img
              crossOrigin="anonymous"
              src="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png"
              srcSet="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png 1x"
              alt=""
              className="w-[150px] h-auto lazyautosizes lazyloaded"
            />
          </div>

          {/* Secure Checkout Text */}
          <div className="font-montserrat text-center leading-none m-0 p-2.5 text-base">
            <p>
              <strong>SECURE CHECKOUT</strong>
            </p>
          </div>

          {/* Desktop Contact Info */}
          <div
            className="font-montserrat text-center"
            style={{
              lineHeight: "1.3",
              margin: "0px",
              padding: "10px",
              textShadow: "transparent 0px 0px 0px",
              fontSize: "18px",
            }}
          >
            <p>
              <strong style={{ fontSize: "23px" }}>CONTACT US:</strong>
            </p>
            <p>info@trymagique.com</p>
          </div>
        </div>

        {/* Mobile Layout */}
        <div
          className="flex md:hidden flex-row items-center justify-between max-w-5xl w-full py-2.5  sm:py-3 px-6 md:px-3"
          style={{ margin: "0px" }}
        >
          {/* Logo */}
          <div className="shrink-0 mr-2">
            <img
              crossOrigin="anonymous"
              src="https://img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png"
              srcSet="https://img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png 1x"
              alt=""
              className="w-38 md:w:24 h-auto lazyautosizes lazyloaded"
            />
          </div>

          {/* Mobile Contact Info */}
          <div
            className="font-montserrat text-right shrink-0"
            style={{
              lineHeight: "1.4",
              margin: "0px",
              padding: "0px",
            }}
          >
            <p className="m-0 mb-1">
              <strong className="text-sm sm:text-base">CONTACT US:</strong>
            </p>
            <p className="m-0 mb-0.5 text-[11px] sm:text-xs break-all">
              info@trymagique.com
            </p>
            <p
              className="m-0 text-[11px] sm:text-xs whitespace-nowrap"
              style={{ color: "rgb(68, 45, 240)" }}
            >
              +1 401-218-0575
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
